import HeaderScrollAni from "./_headerScrollAni";
import SideNav from "./_sideNav";
import LoadMore from "./_loadMore";
import Accordion from "./_accordion";
import Animations from "./_animations";
import QuickContactModal from "./_quickContactModal";
import Modal from "bootstrap/js/dist/modal";
import TabindexHelper from "./_tabIndexHelper";

AUI().ready((A) => {
  new Accordion();
  new HeaderScrollAni();
  new SideNav();
  new LoadMore();
  new Animations();
  new QuickContactModal();
  new TabindexHelper();

  [...document.querySelectorAll("." + Modal.NAME)].forEach(e => new Modal(e));

  // fix "rememberMe" reference errors in Liferay (seems to be a bug in Liferay forms)
  if (typeof rememberMe === 'undefined') {
    window.rememberMe = false;
  }
});
